<form *ngIf="form" [formGroup]="form" class="mat-typography">
    <table>
        <tr>
            <th>Field</th>
            <th>Current Value</th>
            <th>Desired Value</th>
            <th>Status</th>
        </tr>

        <tr>
            <td>Name</td>
            <td>{{ policy?.name || 'No Policy' }}</td>
            <td>{{ desiredPolicyValue?.name }}</td>
            <td>
                <sway-baseline-status [hasError]="errorsString.includes('name')"></sway-baseline-status>
            </td>
        </tr>

        <tr formGroupName="policy">
            <td>Description</td>
            <td>{{ policy?.description }}</td>
            <td>
                <mat-form-field appearance="fill">
                    <textarea matInput formControlName="description"
                        placeholder="Enter a description for the policy"></textarea>
                </mat-form-field>
            </td>
            <td>
                <sway-baseline-status [hasError]="errorsString.includes('description')"></sway-baseline-status>
            </td>
        </tr>

        <tr formGroupName="settings">
            <td>
                <div class="info-wrapper">
                    Backup Directory
                    <mat-icon [matTooltip]="tooltips.backupDirectory">info</mat-icon>
                </div>
            </td>
            <td>
                <div class="validator">{{ backupDirectoryLabel(current.backupDirectory) }}</div>
            </td>
            <td>
                <div class="field">
                    <mat-form-field appearance="fill">
                        <mat-select formControlName="backupDirectory">
                            <mat-option *ngFor="let option of backupDirectoryOptions" [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </td>
            <td>
                <sway-baseline-status
                    [hasError]="current.backupDirectory !== desiredSettingsValue.backupDirectory"></sway-baseline-status>
            </td>
        </tr>

        <!-- Password Age is a directory-specific child, so it only applies once a backup directory is selected. -->
        <tr formGroupName="settings" *ngIf="desiredBackupDirectory == 1">
            <td>
                <div class="info-wrapper">
                    Password Age (Days)
                    <mat-icon [matTooltip]="tooltips.passwordAgeDays">info</mat-icon>
                </div>
            </td>
            <td>
                <div class="validator">{{ current.passwordAgeDays ?? 'Not configured' }}</div>
            </td>
            <td>
                <mat-slide-toggle formControlName="configurePasswordAge">Configure</mat-slide-toggle>
                <mat-form-field *ngIf="desiredSettingsValue.configurePasswordAge" appearance="fill">
                    <input matInput type="number" min="1" max="365" formControlName="passwordAgeDays" />
                </mat-form-field>
                <div *ngIf="!desiredSettingsValue.configurePasswordAge" class="validator">Not configured</div>
            </td>
            <td>
                <sway-baseline-status
                    [hasError]="statusError(desiredSettingsValue.configurePasswordAge, current.passwordAgeDays, desiredSettingsValue.passwordAgeDays)"></sway-baseline-status>
            </td>
        </tr>


        <!-- Active-Directory-only settings (only valid when backing the password up to on-premises AD) -->
        <ng-container *ngIf="desiredBackupDirectory === 2">


            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        AD Password Encryption Enabled
                        <mat-icon [matTooltip]="tooltips.adPasswordEncryptionEnabled">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ optionLabel(adPasswordEncryptionOptions,
                        current.adPasswordEncryptionEnabled) }}</div>
                </td>
                <td>
                    <div class="field boolean">
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="adPasswordEncryptionEnabled">
                                <mat-option *ngFor="let option of adPasswordEncryptionOptions" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="current.adPasswordEncryptionEnabled !== desiredSettingsValue.adPasswordEncryptionEnabled"></sway-baseline-status>
                </td>
            </tr>

            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        Password Expiration Protection Enabled
                        <mat-icon [matTooltip]="tooltips.passwordExpirationProtectionEnabled">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ optionLabel(passwordExpirationProtectionOptions,
                        current.passwordExpirationProtectionEnabled) }}</div>
                </td>
                <td>
                    <div class="field boolean">
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="passwordExpirationProtectionEnabled">
                                <mat-option *ngFor="let option of passwordExpirationProtectionOptions"
                                    [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="current.passwordExpirationProtectionEnabled !== desiredSettingsValue.passwordExpirationProtectionEnabled"></sway-baseline-status>
                </td>
            </tr>

            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        AD Encrypted Password History Size
                        <mat-icon [matTooltip]="tooltips.adEncryptedPasswordHistorySize">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ current.adEncryptedPasswordHistorySize ?? 'Not configured' }}</div>
                </td>
                <td>
                    <mat-slide-toggle
                        formControlName="configureAdEncryptedPasswordHistorySize">Configure</mat-slide-toggle>
                    <mat-form-field *ngIf="desiredSettingsValue.configureAdEncryptedPasswordHistorySize"
                        appearance="fill">
                        <input matInput type="number" min="0" max="12"
                            formControlName="adEncryptedPasswordHistorySize" />
                    </mat-form-field>
                    <div *ngIf="!desiredSettingsValue.configureAdEncryptedPasswordHistorySize" class="validator">
                        Not configured</div>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="statusError(desiredSettingsValue.configureAdEncryptedPasswordHistorySize, current.adEncryptedPasswordHistorySize, desiredSettingsValue.adEncryptedPasswordHistorySize)"></sway-baseline-status>
                </td>
            </tr>

            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        Password Age (Days)
                        <mat-icon [matTooltip]="tooltips.passwordAgeDays">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ current.passwordAgeDays ?? 'Not configured' }}</div>
                </td>
                <td>
                    <mat-slide-toggle formControlName="configurePasswordAge">Configure</mat-slide-toggle>
                    <mat-form-field *ngIf="desiredSettingsValue.configurePasswordAge" appearance="fill">
                        <input matInput type="number" min="1" max="365" formControlName="passwordAgeDays" />
                    </mat-form-field>
                    <div *ngIf="!desiredSettingsValue.configurePasswordAge" class="validator">Not configured</div>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="statusError(desiredSettingsValue.configurePasswordAge, current.passwordAgeDays, desiredSettingsValue.passwordAgeDays)"></sway-baseline-status>
                </td>
            </tr>

            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        AD Password Encryption Principal
                        <mat-icon [matTooltip]="tooltips.adPasswordEncryptionPrincipal">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ current.adPasswordEncryptionPrincipal || 'Domain Admins' }}</div>
                </td>
                <td>
                    <mat-form-field appearance="fill">
                        <input matInput type="text" formControlName="adPasswordEncryptionPrincipal"
                            placeholder="User/group name or SID (blank = Domain Admins)" />
                    </mat-form-field>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="(current.adPasswordEncryptionPrincipal || '') !== (desiredSettingsValue.adPasswordEncryptionPrincipal || '')"></sway-baseline-status>
                </td>
            </tr>


        </ng-container>


        <tr formGroupName="settings">
            <td>
                <div class="info-wrapper">
                    Administrator Account Name
                    <mat-icon [matTooltip]="tooltips.administratorAccountName">info</mat-icon>
                </div>
            </td>
            <td>
                <div class="validator">{{ current.administratorAccountName || 'Built-in administrator' }}</div>
            </td>
            <td>
                <mat-form-field appearance="fill">
                    <input matInput type="text" formControlName="administratorAccountName"
                        [placeholder]="readOnly ? '' : 'Leave blank for built-in administrator'" />
                </mat-form-field>
            </td>
            <td>
                <sway-baseline-status
                    [hasError]="(current.administratorAccountName || '') !== (desiredSettingsValue.administratorAccountName || '')"></sway-baseline-status>
            </td>
        </tr>

        <!-- Top-level settings: independent of the backup directory, so always shown. -->


        <tr formGroupName="settings">
            <td>
                <div class="info-wrapper">
                    Password Complexity
                    <mat-icon [matTooltip]="tooltips.passwordComplexity">info</mat-icon>
                </div>
            </td>
            <td>
                <div class="validator">{{ complexityLabel(current.passwordComplexity) }}</div>
            </td>
            <td>
                <mat-form-field appearance="fill">
                    <mat-select formControlName="passwordComplexity">
                        <mat-option *ngFor="let option of complexityOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <sway-baseline-status
                    [hasError]="current.passwordComplexity !== desiredSettingsValue.passwordComplexity"></sway-baseline-status>
            </td>
        </tr>

        <tr formGroupName="settings">
            <td>
                <div class="info-wrapper">
                    Password Length
                    <mat-icon [matTooltip]="tooltips.passwordLength">info</mat-icon>
                </div>
            </td>
            <td>
                <div class="validator">{{ current.passwordLength ?? 'Not configured' }}</div>
            </td>
            <td>
                <mat-slide-toggle formControlName="configurePasswordLength">Configure</mat-slide-toggle>
                <mat-form-field *ngIf="desiredSettingsValue.configurePasswordLength" appearance="fill">
                    <input matInput type="number" min="8" max="64" formControlName="passwordLength" />
                    <mat-error>Provide an integer between 8 and 64.</mat-error>
                </mat-form-field>
                <div *ngIf="!desiredSettingsValue.configurePasswordLength" class="validator">Not configured</div>
            </td>
            <td>
                <sway-baseline-status
                    [hasError]="statusError(desiredSettingsValue.configurePasswordLength, current.passwordLength, desiredSettingsValue.passwordLength)"></sway-baseline-status>
            </td>
        </tr>


        <tr formGroupName="settings">
            <td>
                <div class="info-wrapper">
                    Post-Authentication Actions
                    <mat-icon [matTooltip]="tooltips.postAuthenticationActions">info</mat-icon>
                </div>
            </td>
            <td>
                <div class="validator">{{ postAuthActionLabel(current.postAuthenticationActions) }}</div>
            </td>
            <td>
                <mat-form-field appearance="fill">
                    <mat-select formControlName="postAuthenticationActions" panelClass="wrap-option-panel">
                        <mat-option *ngFor="let option of postAuthActionOptions" [value]="option.value">
                            {{ option.label }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td>
                <sway-baseline-status
                    [hasError]="statusError(desiredSettingsValue.postAuthenticationActions !== 'notConfigured', current.postAuthenticationActions, desiredSettingsValue.postAuthenticationActions)"></sway-baseline-status>
            </td>
        </tr>

        <tr formGroupName="settings">
            <td>
                <div class="info-wrapper">
                    Post-Authentication Reset Delay (Hours)
                    <mat-icon [matTooltip]="tooltips.postAuthenticationResetDelay">info</mat-icon>
                </div>
            </td>
            <td>
                <div class="validator">{{ current.postAuthenticationResetDelay ?? 'Not configured' }}</div>
            </td>
            <td>
                <mat-slide-toggle formControlName="configurePostAuthenticationResetDelay">Configure</mat-slide-toggle>
                <mat-form-field *ngIf="desiredSettingsValue.configurePostAuthenticationResetDelay" appearance="fill">
                    <input matInput type="number" min="0" max="24" formControlName="postAuthenticationResetDelay" />
                </mat-form-field>
                <div *ngIf="!desiredSettingsValue.configurePostAuthenticationResetDelay" class="validator">Not configured
                </div>
            </td>
            <td>
                <sway-baseline-status
                    [hasError]="statusError(desiredSettingsValue.configurePostAuthenticationResetDelay, current.postAuthenticationResetDelay, desiredSettingsValue.postAuthenticationResetDelay)"></sway-baseline-status>
            </td>
        </tr>

        <tr formGroupName="settings">
            <td>
                <div class="info-wrapper">
                    Automatic Account Management Enabled
                    <mat-icon [matTooltip]="tooltips.automaticAccountManagementEnabled">info</mat-icon>
                </div>
            </td>
            <td>
                <div class="validator">{{ optionLabel(automaticAccountOptions,
                    current.automaticAccountManagementEnabled) }}</div>
            </td>
            <td>
                <div class="field">
                    <mat-form-field appearance="fill">
                        <mat-select formControlName="automaticAccountManagementEnabled">
                            <mat-option *ngFor="let option of automaticAccountOptions" [value]="option.value">
                                {{ option.label }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </td>
            <td>
                <sway-baseline-status
                    [hasError]="statusError(desiredSettingsValue.automaticAccountManagementEnabled !== 'notConfigured', current.automaticAccountManagementEnabled, desiredSettingsValue.automaticAccountManagementEnabled)"></sway-baseline-status>
            </td>
        </tr>

        <!-- Automatic-account-management children (only when the target account is automatically managed). -->
        <ng-container *ngIf="desiredSettingsValue.automaticAccountManagementEnabled === 'enabled'">
            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        Automatic Account Management Target
                        <mat-icon [matTooltip]="tooltips.automaticAccountManagementTarget">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ autoAccountTargetLabel(current.automaticAccountManagementTarget) }}</div>
                </td>
                <td>
                    <div class="field">
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="automaticAccountManagementTarget">
                                <mat-option [value]="'notConfigured'">Not configured</mat-option>
                                <mat-option *ngFor="let option of automaticAccountTargetOptions" [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="statusError(desiredSettingsValue.automaticAccountManagementTarget !== 'notConfigured', current.automaticAccountManagementTarget, desiredSettingsValue.automaticAccountManagementTarget)"></sway-baseline-status>
                </td>
            </tr>

            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        Automatic Account Management Randomize Name
                        <mat-icon [matTooltip]="tooltips.automaticAccountManagementRandomizeName">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ optionLabel(automaticAccountRandomizeNameOptions,
                        current.automaticAccountManagementRandomizeName) }}</div>
                </td>
                <td>
                    <div class="field boolean">
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="automaticAccountManagementRandomizeName">
                                <mat-option *ngFor="let option of automaticAccountRandomizeNameOptions"
                                    [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="statusError(desiredSettingsValue.automaticAccountManagementRandomizeName !== 'notConfigured', current.automaticAccountManagementRandomizeName, desiredSettingsValue.automaticAccountManagementRandomizeName)"></sway-baseline-status>
                </td>
            </tr>

            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        Automatic Account Management Enable Account
                        <mat-icon [matTooltip]="tooltips.automaticAccountManagementEnableAccount">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ optionLabel(automaticAccountEnableAccountOptions,
                        current.automaticAccountManagementEnableAccount) }}</div>
                </td>
                <td>
                    <div class="field boolean">
                        <mat-form-field appearance="fill">
                            <mat-select formControlName="automaticAccountManagementEnableAccount">
                                <mat-option *ngFor="let option of automaticAccountEnableAccountOptions"
                                    [value]="option.value">
                                    {{ option.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="statusError(desiredSettingsValue.automaticAccountManagementEnableAccount !== 'notConfigured', current.automaticAccountManagementEnableAccount, desiredSettingsValue.automaticAccountManagementEnableAccount)"></sway-baseline-status>
                </td>
            </tr>

            <tr formGroupName="settings">
                <td>
                    <div class="info-wrapper">
                        Automatic Account Management Name Or Prefix
                        <mat-icon [matTooltip]="tooltips.automaticAccountManagementNameOrPrefix">info</mat-icon>
                    </div>
                </td>
                <td>
                    <div class="validator">{{ current.automaticAccountManagementNameOrPrefix  }}</div>
                </td>
                <td>
                    <mat-form-field appearance="fill">
                        <input matInput type="text" formControlName="automaticAccountManagementNameOrPrefix"
                            [placeholder]=" readOnly ? '' : 'Account name/prefix (blank = WLapsAdmin)'" />
                    </mat-form-field>
                </td>
                <td>
                    <sway-baseline-status
                        [hasError]="(current.automaticAccountManagementNameOrPrefix || '') !== (desiredSettingsValue.automaticAccountManagementNameOrPrefix || '')"></sway-baseline-status>
                </td>
            </tr>
        </ng-container>


    </table>

    <app-intune-policy-assignments [policy]="policy" [errorsString]="errorsString" [assignments]="assignments"
        [form]="form" [tenant_id]="tenant_id"> </app-intune-policy-assignments>
</form>
